<!--
 * @Author: gaobin
 * @Date: 2025-05-13 00:28:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-30 11:36:33
 * @Description: 页面js 加载失败的页面
-->
<template>
  <view class="flex-column-center-center err-container" :dir="dir">
    <template v-if="hasStayed12s">
      <view class="err-info">
        <text>{{ t('noNetwork') }}</text>
      </view>
      <button
        class="primary-btn flex-center f-w-bold reload-button"
        type="primary"
        @click="onReload"
      >
        {{ t('reload') }}
      </button>
    </template>
    <view v-else class="loading-box absolute-layout flex-column-center-center">
      <view class="loader"></view>
    </view>
  </view>
</template>

<script setup>
import { onMounted } from 'vue';

const { t } = useI18n();

const store = useStore();

// 时间戳
const timestamp = ref(new Date().getTime());

// 倒计时
const stayTimer = ref(null);
const hasStayed12s = ref(false);

const dir = computed(() => {
  // 根据当前语言设置布局方向
  const language = store?.state?.user?.lang || 'zh';
  return language === 'ar' ? 'rtl' : 'ltr';
});

onMounted(() => {
  // 组件挂载时开始计时
  stayTimer.value = setTimeout(() => {
    hasStayed12s.value = true;
  }, 12000); // 12秒 = 12000毫秒

  const opT = new URLSearchParams(window.location.search).get('t');
  if (opT) {
    const diff = Math.abs(timestamp.value - Number(opT));
    if (diff > 12000) {
      // 12s之内不重新加载
      onReload();
    }
  } else {
    onReload();
  }
});

// 点击重新加载
const onReload = () => {
  const newUrl = new URL(window.location.href); // 获取当前URL
  const searchParams = Object.fromEntries(new URLSearchParams(window.location.search));
  const newParams = { ...searchParams, t: timestamp.value }; // 新的查询参数
  // console.log('paramsArray', newParams);
  newUrl.search = new URLSearchParams(newParams).toString(); // 更新查询参数
  history.replaceState({ path: newUrl.href }, '', newUrl.href); // 替换当前URL但不重新加载页面
  // 重新加载当前页面
  // #ifdef APP-PLUS
  uni.reLaunch({
    url: getCurrentPages()[0].route,
  });
  // #endif

  // #ifdef H5
  window.location.replace(window.location.href);
  // #endif
};

// 组件卸载时
onBeforeUnmount(() => {
  // 组件销毁前清除计时器
  if (stayTimer.value) {
    clearTimeout(stayTimer.value);
  }
});
</script>
<style lang="scss" scoped>
.err-info {
  margin-top: 48rpx;
  margin-bottom: 48rpx;
  text-align: center;
}
.reload-button {
  color: #fff;
  background: linear-gradient(180deg, #ff6000 0%, #c2382d 100%);
  width: 400rpx;
  border-radius: 8rpx;
  height: 76rpx;
  margin-top: 48rpx;
  font-weight: bold;
  font-size: 28rpx;
}
.err-container {
  padding: 340rpx 60rpx 0 60rpx;
}

// 加载动画3
.loading-box {
  width: 168rpx;
  height: 170rpx;
  border-radius: 12px;
}

.absolute-layout {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.loader {
  width: 56rpx;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, #ff6000 100%, #0000) top/8rpx 8rpx no-repeat,
    conic-gradient(#0000 10%, #ff6000);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8rpx), #000 0);
  animation: l13 1s infinite linear;
}

@keyframes l13 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
